import React from 'react'

import Welcome from '../Welcome'
import Question from '../Question'
import Result from '../Result'

import { maxSecond, questionsCount, pictureInQuestionCount } from 'constants/params'

import 'normalize.css/normalize.css'
import 'csshake/dist/csshake.min.css'
import './general-styles.css'

import classes from './styles'

let pastFirstQuestionId = null
const picturesThatNeedToLoadCount = questionsCount * pictureInQuestionCount

class App extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      picturesThatNeedToLoadCount: picturesThatNeedToLoadCount
    }
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.questions.length === 0) return

    this._preloadFirsImages(nextProps)

    this._checkAndEndGame(nextProps)
  }

  _preloadFirsImages = (nextProps) => {
    const firstQuestion = nextProps.questions[0]

    if (pastFirstQuestionId === firstQuestion.id) return

    this.setState({
      picturesThatNeedToLoadCount: picturesThatNeedToLoadCount
    })

    nextProps.questions.forEach(q => {
      q.pictures.forEach(p => {
        const i = new Image()
        i.onerror = this.resetGame
        i.onload = this._increasePicturesThatNeedToLoadCount
        i.src = p.src
      })
    })

    pastFirstQuestionId = firstQuestion.id
  }

  _increasePicturesThatNeedToLoadCount = () => {
    this.setState({
      picturesThatNeedToLoadCount: this.state.picturesThatNeedToLoadCount - 2
    })
  }

  _checkAndEndGame = (nextProps) => {
    const { currentQuestionIndex, questions, timer, isTestEnd, appActions } = nextProps

    const isQuestionOver = currentQuestionIndex >= questions.length
    const isTimeExpire = timer >= maxSecond
    const isTestEndNow = isQuestionOver || isTimeExpire

    if (isTestEndNow && !isTestEnd) appActions.end()
  }

  resetGame = () => {
    window.ga('send', 'event', 'Переходы', 'Повторное прохождение', 'picture')

    this.props.appActions.reset()
    this.props.questionActions.reset()
  }

  render() {
    const {
      questions,
      currentQuestionIndex,
      isLoading,
      isTestStart,
      isTestEnd,
      timer,
      score,
      lastScoreModification,
      appActions,
      questionActions,
    } = this.props

    const isAllPicturesLoad = this.state.picturesThatNeedToLoadCount <= 0

    return (
      <div className={classes.app}>
        <img className={[classes.leftTop, classes.angle].join(' ')} src={`${process.env.PUBLIC_URL}/rounded.svg`} alt=""/>
        <img className={[classes.rightTop, classes.angle].join(' ')} src={`${process.env.PUBLIC_URL}/rounded.svg`} alt=""/>
        <img className={[classes.leftBottom, classes.angle].join(' ')} src={`${process.env.PUBLIC_URL}/rounded.svg`} alt=""/>
        <img className={[classes.rightBottom, classes.angle].join(' ')} src={`${process.env.PUBLIC_URL}/rounded.svg`} alt=""/>

        {(isTestStart && !isLoading) ?
          <div style={{ height: '100%' }}>
            {isTestEnd ?
              <Result
                questions={questions}
                timer={timer}
                currentQuestionIndex={currentQuestionIndex}
                reset={this.resetGame}
                score={score}
              />
              :
              <Question
                question={questions[currentQuestionIndex]}
                nextQuestion={questions[currentQuestionIndex + 1]}
                answer={questionActions.answer}
                modifyScore={appActions.modifyScore}
                end={questionActions.end}
                tick={appActions.tick}
                score={score}
                timer={timer}
                lastScoreModification={lastScoreModification}
                maxSecond={maxSecond}
              />
            }
          </div>
          :
          <Welcome
            isLoading={isLoading || !isAllPicturesLoad}
            start={appActions.start}
          />
        }
      </div>
    )
  }
}

/*
*/

App.propTypes = {
  questions: React.PropTypes.array.isRequired,
  currentQuestionIndex: React.PropTypes.number.isRequired,
  isLoading: React.PropTypes.bool.isRequired,
  isTestStart: React.PropTypes.bool.isRequired,
  timer: React.PropTypes.number.isRequired,
  appActions: React.PropTypes.object.isRequired,
  questionActions: React.PropTypes.object.isRequired,
}

export default App



// WEBPACK FOOTER //
// ./src/components/App/App.js